import { Helmet } from "react-helmet-async";
import { connect } from "react-redux";
import { PreviewController } from "../../controllers";
import Cookies from "js-cookie";
import routes from "../../../core/routes";
import { Button } from "../../components";

class Preview extends PreviewController {

  async componentDidMount() {
    window.scrollTo(0, 0);
  
    const token = Cookies.get("acto");
    if (!token) {
      window.location.href = `${process.env.REACT_APP_SSO_URL}/`;
      return;
    }
  
    const urlParams = new URLSearchParams(window.location.search);
    const agentQueryParam = urlParams.get("agent");
    const tokenQueryParam = window.location.pathname.split("/")[1];
  
    if (agentQueryParam) {
      const isValid = await this.checkReferralCode(agentQueryParam);
      if (isValid) {
      this.setTemporaryQueryParams();
      }else {
        this.props.dispatch(this.getProfile());
        return;
      }
    }
  
    if (tokenQueryParam) {
      this.getTemporaryQueryParams(tokenQueryParam);
    }
  
    if (!agentQueryParam && !tokenQueryParam) {
      this.props.dispatch(this.getProfile());
    }
  }
  
  render() {
    return (
      <div className="preview">
        <Helmet>
          <title></title>
        </Helmet>
        {this.state.showAgentUpdateModal ? (
    <div className="preview-box">
      <p>کد معرف قبلی "<strong>{this.state.currentAgentCode} </strong> " با کد جدید " <strong> {this.state.newAgentCode} </strong> " متفاوت است.</p>
      <p>آیا مایل به بروزرسانی هستید؟</p>
      <div className="preview-box-actions">
        <Button
          onClick={() => 
            this.props.dispatch(this.updateProfile(this.state.newAgentCode))
          }
          title=" بله، بروزرسانی کن" 
          />
        <Button
          onClick={() => {
            this.setState({ showAgentUpdateModal: false }, () => {
              window.location.href = `${routes.DASHBOARD}`;
            });
          }}
          myStyle="bg-blue"
          title="          خیر، بازگشت به داشبورد          " 
          />
    </div>
  </div> ) : (
        <div className="preview-content">
          <div className="loader mb-5"></div>
          <p className="content-title">
            در حال انتقال به داشبورد                     </p>
          <p className="content-desc">
            در حال آماده سازی برای انتقال به نمایه هستید                        </p>
          <p className="content-desc">
            منتظر بمانید ...                     </p>
        </div> 
        )}
      </div>
    )
  }
}

const mapStateToProps = (dispatch: any) => {
  return {
    dispatch,
    userData: dispatch.general.userData,
  }
};

export default connect(mapStateToProps)(Preview);